import { Row } from './DesignSystem';

export type TileHeaderProps = {};
export function TileHeader({
  children,
}: React.PropsWithChildren<TileHeaderProps>) {
  return (
    <Row
      style={{
        height: '40px',
        width: '100%',
        alignItems: 'center',
        backgroundColor: '#ffffffe0',
        borderBottom: '1px solid #00000022',
      }}
    >
      {children}
    </Row>
  );
}
